<div class="dialog-content" role="alertdialog" aria-labelledby="dialog-title" aria-describedby="dialog-message">
  <div class="dialog-close">
    <oph-x-button (buttonClick)="onCancel()" aria-label="Close dialog"></oph-x-button>
  </div>

  <div class="dialog-body">
    <img
      ngSrc="assets/img/icons/challenge-builder/traffic-cone.png"
      alt=""
      width="75"
      height="78"
      priority
      class="dialog-icon"
    />

    <h2 id="dialog-title" class="dialog-title">{{ title() }}</h2>
    <p id="dialog-message" class="dialog-message">{{ message() }}</p>

    <div class="dialog-actions">
      <oph-button
        color="green"
        [loading]="loading()"
        [disabled]="loading()"
        (buttonClick)="onConfirm()"
        [style]="{'border-radius': '8px', width: '227px', height: '42px', 'font-size': '15px'}"
      >
        {{ confirmButtonText() }}
      </oph-button>

      <oph-button
        appearance="outline"
        color="gray"
        [disabled]="loading()"
        (buttonClick)="onCancel()"
        [style]="{'border-radius': '8px', width: '227px', height: '42px', 'font-size': '15px'}"
      >
        Cancel
      </oph-button>
    </div>
  </div>
</div>
